module.exports = __webpack_public_path__ + "img/type-orange.ddb32a18.png";